export const editWebConstants = {
    GET_EDIT_CONTENT_WEB_PENDING  : 'GET_EDIT_CONTENT_WEB_PENDING',
    GET_EDIT_CONTENT_WEB_FULFILLED: 'GET_EDIT_CONTENT_WEB_FULFILLED',
    GET_EDIT_CONTENT_WEB_REJECTED : 'GET_EDIT_CONTENT_WEB_REJECTED',

    UPDATE_EDIT_CONTENT_WEB_PENDING  : 'UPDATE_EDIT_CONTENT_WEB_PENDING',
    UPDATE_EDIT_CONTENT_WEB_FULFILLED: 'UPDATE_EDIT_CONTENT_WEB_FULFILLED',
    UPDATE_EDIT_CONTENT_WEB_REJECTED : 'UPDATE_EDIT_CONTENT_WEB_REJECTED',
};
